
  // Забрана на десен клик
  document.addEventListener('contextmenu', e => e.preventDefault());
  
  // Забрана на copy, cut, paste
  document.addEventListener('copy', e => e.preventDefault());
  document.addEventListener('cut', e => e.preventDefault());
  
  // Забрана на drag (за снимки)
  document.addEventListener('dragstart', e => e.preventDefault());
  
  // Забрана на клавишни комбинации
  document.addEventListener('keydown', e => {
    // Ctrl+C, Ctrl+X, Ctrl+S, Ctrl+U, Ctrl+P
    if (e.ctrlKey && ['c','x','s','u','p','a'].includes(e.key.toLowerCase())) {
      e.preventDefault();
    }
    // F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+Shift+C (dev tools)
    if (e.key === 'F12' || 
        (e.ctrlKey && e.shiftKey && ['I','J','C'].includes(e.key))) {
      e.preventDefault();
    }
  });
